import React from "react";
import "../assets/css/content-loader.css";

interface ContentLoaderProps {
  /** Optional status text under the spinner */
  label?: string;
  /** Compact height for nested panels / table slots */
  compact?: boolean;
  /** Full content-area height with white background (route-level loads) */
  page?: boolean;
  className?: string;
}

/**
 * Standard in-app data loader — centers a spinner in the content area only.
 * Never uses fixed/fullscreen positioning (keeps sidebar/shell intact).
 */
const ContentLoader: React.FC<ContentLoaderProps> = ({
  label = "Loading…",
  compact = false,
  page = false,
  className = "",
}) => {
  return (
    <div
      className={[
        "content-loader",
        compact ? "content-loader--compact" : "",
        page ? "content-loader--page" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="content-loader__spinner" aria-hidden="true" />
      {label ? <p className="content-loader__label">{label}</p> : null}
    </div>
  );
};

export default ContentLoader;
